
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import api from "@/services/api"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { ViewSummary } from "@/types/views/viewSummary"
import ViewFolders from "../Folders/ViewFolders.vue"
import { Folder, FolderType, FolderItem } from "@/types/folder"

const caseStore = namespace("cases")

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar,
			"view-folders": ViewFolders
		}
	})
export default class CaseFilters extends Vue {
	@Getter("getScreenWidth") public screenWidth!: number;

	@Prop({ type: Array, default: [] })
	private readonly views!: ViewSummary[];

	@Prop({ type: String, default: "" })
	private readonly activeViewId!: string | null;

	@Prop({ type: String, default: "" })
	private readonly searchFilter!: string;

	private isMounted: boolean = false

	folders: Folder[] = []

	public gotoPage (viewId: string) {
		this.$emit("changeView", viewId)
	}

	public async mounted () {
		// Get the list of View folders
		this.folders = await api.foldersGet(FolderType.View)
		this.isMounted = true
	}

	get viewsAsFolderItems (): FolderItem[] {
		return this.views.map((view: ViewSummary) => {
			return {
				...view,
				itemCount: view.caseCount
			}
		}) as FolderItem[]
	}
}
